// ListService,js

import Immutable from 'immutable';
import util      from 'util/Util.js';
import constants from 'Constants.js';
import factoryService from 'FactoryService.js';

//====================================================================================================================
//
//====================================================================================================================
class ControlPropertiesService {

    getControlProperties (factory_key){
        let result= [];
        switch (factory_key.toLowerCase()) {
            case 'control_text':
            case 'control_small_text':
            case 'control_large_heading':
            case 'control_medium_heading':
            case 'control_small_heading':
                result = [
                    {name: 'Left Position', value: 'left'},
                    {name: 'Top Position', value: 'top'},
                    {name: 'Width', value: 'width'},
                    {name: 'Height', value: 'height'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                        {name: 'Text', value: 'text'},
                        {name: 'Font', value: 'font'},
                        {name: 'Text Color', value: 'textColor'},
                        {name: 'Is Html', value: 'isHtml'},
                        {name: 'Align', value: 'align'},
                        {name: 'Encrypt', value: 'encrypt'},
                        {name: 'Line Height', value: 'lineHeight'},
                        {name: 'Spacing', value: 'spacing'},
                        {name: 'Letter Spacing', value: 'letterSpacing'},
                        {name: 'Word Spacing', value: 'wordSpacing'}
                ];
                break;
            case 'control_link':
                result = [ {name: 'Left Position', value: 'left'},
                        {name: 'Top Position', value: 'top'},
                    {name: 'Width', value: 'width'},
                    {name: 'Height', value: 'height'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Is Html', value: 'isHtml'},
                    {name: 'Align', value: 'align'},
                    {name: 'Mouse over text color', value: 'mouseOverTextColor'},
                    {name: 'Target', value: 'target'} ];
                break;
            case 'control_bullet_text':
                result = [ {name: 'Left Position', value: 'left'},
                    {name: 'Top Position', value: 'top'},
                    {name: 'Width', value: 'width'},
                    {name: 'Height', value: 'height'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Line Height', value: 'lineHeight'},
                    {name: 'Spacing', value: 'spacing'},
                    {name: 'Letter Spacing', value: 'letterSpacing'},
                    {name: 'Word Spacing', value: 'wordSpacing'} ];
                break;
            case 'control_picture' :
                result = [ {name: 'Left Position', value: 'left'},
                    {name: 'Top Position', value: 'top'},
                    {name: 'Width', value: 'width'},
                    {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Mantain Aspect Radio', value: 'maintainAspectRatio'},
                    {name:'Stretch', value: 'stretch'},
                    {name:'Source URL', value: 'sourceUrl'},
                    {name:'Source Attachment', value: 'sourceAttachment'}
                ];
                break;
            case 'control_button':
            case 'control_submit_button':
            case 'control_print_button':
            case 'control_play_form_button':
            case 'control_play_report_button':
            case 'control_clear_filter_button':
                result = [
                    {name: 'Left Position', value: 'left'},
                    {name: 'Top Position', value: 'top'},
                    {name: 'Width', value: 'width'},
                    {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Border Color', value: 'borderColor'},
                    {name: 'Background Gradient Color', value: 'bgGradientColor'},
                    {name: 'Button Style', value: 'buttonStyle'} ];
                break;
            case 'control_page_button':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},{name: 'Border Color', value: 'borderColor'},
                    {name: 'Background Gradient Color', value: 'bgGradientColor'},
                    {name: 'Button Style', value: 'buttonStyle'},
                    {name: 'Page Type', value: 'pageType'} ];
                break;
            case 'control_text_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Max Chars', value: 'maxChars'},
                    {name: 'Border', value: 'border'},
                    {name: 'Border Color', value: 'borderColor'},
                    {name: 'Align', value: 'align'},
                    {name: 'Format', value: 'format'},
                    {name: 'Custom Format', value: 'customFormat'},
                    {name: 'Letter Spacing', value: 'letterSpacing'},
                    {name: 'Word Spacing', value: 'wordSpacing'} ];
                break;
            case 'control_multiple_text_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, {name: 'Max Chars', value: 'maxChars'},
                    {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'},
                    {name: 'Align', value: 'align'},
                    {name: 'Vertical Scrollbar', value: 'verticalScroll'},
                    {name: 'Horizontal Scrollbar', value: 'horizontalScroll'},
                    {name: 'Line Height', value: 'lineHeight'},
                    {name: 'Spacing', value: 'spacing'},
                    {name: 'Letter Spacing', value: 'letterSpacing'},
                    {name: 'Word Spacing', value: 'wordSpacing'}];
                break;
            case 'control_numeric_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'},
                    {name: 'Allow Negative', value: 'allowNegative'},
                    {name: 'Decimal Length', value: 'decimalLength'},
                    {name: 'Min', value: 'min'},
                    {name: 'Max', value: 'max'},
                    {name: 'Decimal Separator', value: 'decimalSeparator'},
                    {name: 'Thousand Separator', value: 'thousandsSeparator'} ];
                break;
            case 'control_date_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Minimum Year', value: 'minYear'},
                    {name: 'Maximum Year', value: 'maxYear'},
                    {name: 'Format', value: 'format'},
                    {name: 'Border Color', value: 'borderColor'} ];
                break;
            case 'control_time_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'is 24 Hour Clock', value: 'is24HourClock'},
                    {name: 'Has Seconds', value: 'hasSeconds'},
                    {name: 'Border Color', value: 'borderColor'} ];
                break;
            case 'control_date_calendar':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Minimum Year', value: 'minYear'},
                    {name: 'Maximum Year', value: 'maxYear'},
                    {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'} ];
                break;
            case 'control_drop_down':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, {name: 'Selected Index', value: 'selectedIndex'}, {name: 'Border Color', value: 'borderColor'} ];
                break;
            case 'control_list':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Selected Indices', value: 'selectedIndices'},
                    {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'} ];
                break;
            case 'control_checkbox':
            case 'control_radio_button':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'} ];
                break;
            case 'control_vertical_separator':
            case 'control_horizontal_separator':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'},
                    {name: 'Line Color', value: 'lineColor'} ];
                break;
            case 'control_sound':
                result = [
                    {name: 'Auto-play', value: 'autoPlay'},
                    {name: 'Loop', value: 'loop'},
                    {name: 'Volume', value: 'volume'}
                    ];
                break;
            case 'control_movie':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'},
                    {name: 'Maintain Aspect Ratio', value: 'maintainAspectRatio'},
                    {name: 'Auto-play', value: 'autoPlay'},
                    {name: 'Loop', value: 'loop'},
                    {name: 'Volume', value: 'volume'} ];
                break;
            case 'control_progress_bar':
                result = [
                    {name: 'Value', value: 'value'},
                    {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'},
                    {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, 'Bar Color', {name: 'Border Color', value: 'borderColor'},
                    {name: 'Label', value: 'label'},
                    {name: 'Show Label', value: 'showLabel'},
                    {name: 'Auto Label', value: 'autoValue'} ];
                break;
            case 'control_timer':
                result = [ {name: 'Time', value: 'time'},
                    {name: 'Start Time', value: 'startTime'},
                    {name: 'End Time', value: 'endTime'},
                    {name: 'Interval', value: 'interval'},
                    {name: 'Loop', value: 'loop'},
                    {name: 'Direction', value: 'direction'} ];
                break;
            case 'control_captcha':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Background Color', value: 'backgroundColor'}, {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Length', value: 'length'},
                    {name: 'Text Color', value: 'textColor'} ];
                break;
            case 'control_mask_text_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'},
                    {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, {name: 'Mask', value: 'mask'}, {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'} ];
                break;
            case 'control_numeric_stepper':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, 'Max', 'Min', 'Step Size', {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'}];
                break;
            case 'control_password_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, {name: 'Max Chars', value: 'maxChars'},
                    {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'},
                    {name: 'Align', value: 'align'}, {name: 'Format', value: 'format'} ];
                break;
            case 'control_file_attachment':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'},
                    {name: 'Text Color', value: 'textColor'},
                    {name: 'Button Font', value: 'buttonFont'},
                    {name: 'Button Text Color', value: 'buttonTextColor'},
                    {name: 'Button Background Color', value: 'buttonBackgroundColor'},
                    {name: 'Button Background Gradient Color', value: 'buttonBackgroundGradientColor'},
                    {name: 'Button on Left', value: 'buttonPositionLeft'} ];
                break;
            case 'control_image_input':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'},
                    {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Maximum Size', value: 'maxSize'},
                    {name: 'Button Font', value: 'buttonFont'},
                    {name: 'Button Text Color', value: 'buttonTextColor'},
                    {name: 'Button Background Color', value: 'buttonBackgroundColor'},
                    {name: 'Button Background Gradient Color', value: 'buttonBackgroundGradientColor'}];
                break;
            case 'control_websignature':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Text', value: 'text'},
                    {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Button Font', value: 'buttonFont'},
                    {name: 'Button Text Color', value: 'buttonTextColor'},
                    {name: 'Button Background Color', value: 'buttonBackgroundColor'},
                    {name: 'Button Background Gradient Color', value: 'buttonBackgroundGradientColor'} ];
                break;
            case 'control_vertical_slider':
            case 'control_horizontal_slider':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'},
                    {name: 'Font', value: 'font'},
                    {name: 'Text Color', value: 'textColor'},
                    {name: 'Min Text', value: 'minText'},
                    {name: 'Max Text', value: 'maxText'},
                    {name: 'Min Value', value: 'minValue'},
                    {name: 'Max Value', value: 'maxValue'},
                    {name: 'Snap Interval', value: 'snapInterval'},
                    {name: 'Slider Color', value: 'sliderColor'},
                    {name: 'Tick Interval', value: 'tickInterval'},
                    {name: 'Tick Color', value: 'tickColor'} ];
                break;
            case 'control_ranking':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'}, {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'} ];
                break;
            case 'control_table':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'}, {name: 'Background Color', value: 'backgroundColor'}, {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Header Font', value: 'headerFont'},
                    {name: 'Header Text Color', value: 'headerTextColor'},
                    {name: 'Header Background Color', value: 'headerBgColor'},
                    {name: 'Header Background Color Gradient', value: 'headerBgColorGradient'},
                    {name: 'Normal Row Background Color', value: 'normalRowBgColor'},
                    {name: 'Alternate Row Background Color', value: 'alternateRowBgColor'},
                    {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'},
                    {name: 'Max Rows', value: 'maxRows'},
                    {name: 'Header Height', value: 'headerHeight'},
                    {name: 'Row Height', value: 'rowHeight'},
                    {name: 'Resizable columns', value: 'allowColumnResize'},
                    {name: 'Buttons', value: 'buttons'} ];
                break;
            case 'page_instance':
                result = [ {name: 'Background Color', value: 'backgroundColor'} ];
                break;
            case "control_group":
            case "control_checkbox_group":
            case "control_radio_button_group":
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Border', value: 'border'},
                    {name: 'Border Color', value: 'borderColor'} ];

                break;            
            case "control_group_with_header":
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'},
                    {name: 'Tooltip', value: 'tooltip'},
                    {name: 'Layer', value: 'layer'},
                    {name: 'Border', value: 'border'},
                    {name: 'Border Color', value: 'borderColor'},
                    {name: 'Header Caption', value: 'titleText'},
                    {name: 'Header Font', value: 'titleFont'},
                    {name: 'Header Caption Color', value: 'titleColor'},
                    {name: 'Header Align', value: 'titleAlign'},
                    {name: 'Header Background Color', value: 'titleBackgroundColor'}, 
                    {name: 'Header Height', value: 'titleHeight'}
                ];
    
                break;
            case 'control_pie_chart':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Pie-Chart Labels Positions', value: 'pieLabelsPositions'} ];
                break;
            case 'control_bar_chart':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Horizontal Axis', value: 'horizontalAxis'}, {name: 'Vertical Axis', value: 'verticalAxis'}, {name: 'Bar-Chart Type', value: 'barChartType'} ];
                break;
            case 'control_line_chart':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Horizontal Axis', value: 'horizontalAxis'}, {name: 'Vertical Axis', value: 'verticalAxis'}, {name: 'Line-Chart Type', value: 'lineChartType'} ];
                break;
            case 'control_data_grid':
            case 'control_data_list':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                    {name: 'Background Color', value: 'backgroundColor'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                    {name: 'Header Font', value: 'headerFont'},
                    {name: 'Header Text Color', value: 'headerTextColor'},
                    {name: 'Header Background Color', value: 'headerBgColor'},
                    {name: 'Normal Row Background Color', value: 'normalRowBgColor'},
                    {name: 'Alternate Row Background Color', value: 'alternateRowBgColor'},
                    {name: 'Show Navigation Buttons', value: 'showNavButtons'},
                    {name: 'Show Data Info', value: 'showDsInfo'} ];
                break;
            case 'control_crosstab':
            case 'control_value':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                {name: 'Background Color', value: 'backgroundColor'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'} ];
                break;            
            case 'control_gauge_chart':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                {name: 'Background Color', value: 'backgroundColor'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                {name: 'Min Value', value: 'minValue'}, {name: 'Max Value', value: 'maxValue'} ];
                break;
            case 'control_filter_input':
            case 'control_filter_selector':
                result = [ {name: 'Left Position', value: 'left'}, {name: 'Top Position', value: 'top'}, {name: 'Width', value: 'width'}, {name: 'Height', value: 'height'},
                {name: 'Background Color', value: 'backgroundColor'}, {name: 'Tooltip', value: 'tooltip'}, {name: 'Layer', value: 'layer'}, {name: 'Font', value: 'font'}, {name: 'Text Color', value: 'textColor'},
                {name: 'Align', value: 'align'}, {name: 'Border', value: 'border'}, {name: 'Border Color', value: 'borderColor'} ];
                break;
        }
        return result;
    }


}

const controlPropertiesService = new ControlPropertiesService();
export default controlPropertiesService;
